import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddDoctorForm from "./components/AddDoctorForm";
import { UserPlus, ArrowLeft, Users } from "lucide-react";

const AddDoctorPage = () => {
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [createdDoctor, setCreatedDoctor] = useState(null);

  const handleSuccess = (doctorData) => {
    setCreatedDoctor(doctorData);
    setShowSuccessModal(true);
  };

  const handleCancel = () => {
    navigate("/dashboard"); // or wherever you want to redirect
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    navigate("/dashboard"); // Navigate to doctors list after success
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      {/* <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/doctors')}
                className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Back to Doctors
              </button>
              <div className="border-l border-gray-300 h-6"></div>
              <h1 className="text-xl font-semibold text-gray-900">Add New Doctor</h1>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <Users className="w-4 h-4" />
              <span>Doctor Management</span>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <AddDoctorForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                <UserPlus className="h-6 w-6 text-green-600" />
              </div>

              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Doctor Profile Created Successfully!
              </h3>

              {createdDoctor && (
                <div className="text-sm text-gray-600 mb-4">
                  <p>
                    <strong>Name:</strong> {createdDoctor.doctorDetails?.name}
                  </p>
                  <p>
                    <strong>Email:</strong>{" "}
                    {createdDoctor.doctorDetails?.contact?.email}
                  </p>
                  <p>
                    <strong>User ID:</strong> {createdDoctor.user?.id}
                  </p>
                </div>
              )}

              <p className="text-sm text-gray-500 mb-6">
                The doctor profile has been created and a user account has been
                set up. The doctor can now log in with their email and the
                default password.
              </p>

              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    setShowSuccessModal(false);
                    // Reset form for adding another doctor
                  }}
                  className="flex-1 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 transition-colors"
                >
                  Add Another Doctor
                </button>
                <button
                  onClick={closeSuccessModal}
                  className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 transition-colors"
                >
                  Go to Doctors List
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddDoctorPage;
